const resolveObject = (value) => (value && typeof value === "object" ? value : {});

const hasValue = (value) => {
  if (value === null || value === undefined) {
    return false;
  }

  if (typeof value === "string") {
    return value.trim().length > 0;
  }

  if (typeof value === "number") {
    return Number.isFinite(value);
  }

  if (typeof value === "boolean") {
    return value;
  }

  if (Array.isArray(value)) {
    return value.length > 0;
  }

  if (typeof value === "object") {
    return Object.keys(value).length > 0;
  }

  return false;
};

const REQUIRED_PERSONAL_INFO_FIELDS = [
  "firstName",
  "lastName",
  "dateOfBirth",
  "phoneNumber",
  "streetAddress",
  "city",
  "province",
  "postalCode",
];

export const isCustomerPersonalInfoComplete = (customer) => {
  const customerRecord = resolveObject(customer);
  const personalInfo = resolveObject(customerRecord.personalInfo);

  return REQUIRED_PERSONAL_INFO_FIELDS.every((fieldName) => hasValue(personalInfo[fieldName]));
};

export const hasCompletedBankVerification = (customer) => {
  const customerRecord = resolveObject(customer);
  const verificationInfo = resolveObject(customerRecord.verificationInfo);

  if (hasValue(verificationInfo.bank)) {
    return true;
  }

  return Object.values(verificationInfo).some((entry) => hasValue(entry));
};
